export default {
  api: process.env.NODE_ENV === 'production' ? 'https://api.dewildeapp.nl/api/v2' : 'http://127.0.0.1:8011/api/v2',
  appUrl: process.env.NODE_ENV === 'production' ? 'https://api.dewildeapp.nl' : 'http://127.0.0.1:8011',
  startDateOffset: -14,
  dateLookForward: 365,
  token: 'yx9GXrlCOlO6VS7O3aMdna6sqOc4cLXrjLezIssi',
  writeAccess: false,
};



// WEBPACK FOOTER //
// ./src/config.js